import React from "react";
import { Link } from "react-router-dom";

const NavItem = ({ funcTips }) => {
  return (
    <div className="flex justify-center space-x-12">
      {funcTips.map((item) => {
        if (item.title === "首页") {
          return (
            <Link key={item.key} to={`/`}>
              {item.title}
            </Link>
          );
        }
        return (
          <Link className="flex justify-center space-x-12" key={item.key} to={`/${item.key}`}>
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

export default NavItem;
